import React from "react";
import Modal from "react-modal";
import { AxiosResponse } from "axios";

import { IServiceCategory, IPageContent } from "app/api/types";
import AddServiceCategory from "./components/AddServiceCategory";

import ServiceCategory from "./components/ServiceCategory";
import BackButton from "app/features/BackButton";
import Loader from "app/components/Loader";

import "./styles.scss";

interface IProps {
  serviceCategoriesList: IServiceCategory[];
  isLoading: boolean;
  addServiceCategory: (data: IServiceCategory) => Promise<IServiceCategory>;
  delServiceCategory: (data: IServiceCategory["id"]) => Promise<AxiosResponse>;
  editServiceCategory: (data: IServiceCategory) => Promise<IServiceCategory>;
  getServiceCategories: () => Promise<AxiosResponse>;
  addPageContent: (data: IPageContent) => Promise<AxiosResponse>;
  editPageContent: (data: IPageContent) => Promise<AxiosResponse>;
  getPageContentById: (id: string) => Promise<[IPageContent]>;
  delPageContent: (schemeId: IPageContent["pageId"]) => Promise<AxiosResponse>;
}

interface IState {
  modalIsOpen: boolean;
  isSuccessActive: boolean;
  isSubmit: boolean;
}

const schemeContent = [
  {
    id: "main-banner",
    title: "Банер(изображение)(1500x400)",
    src: "",
  },
  {
    id: "main-banner-description",
    title: "Банер(название)",
    text: "",
  },
  {
    id: "category-info",
    title: "Описание(для главной страницы)",
    text: "",
  },
];

Modal.setAppElement("#root");

class ServiceCategoriesList extends React.Component<IProps, IState> {
  state = {
    modalIsOpen: false,
    isSuccessActive: false,
    isSubmit: false,
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  addServiceCategory = (data: IServiceCategory) => {
    this.props.addServiceCategory(data).then((serviceCategory) => {
      this.props.editServiceCategory({
        ...serviceCategory,
        href: `service-category.${serviceCategory.id}`,
      });

      this.props.addPageContent({
        pageId: `service-category.${serviceCategory.id}`,
        pageTitle: serviceCategory.title,
        content: schemeContent,
      });
      this.props.getServiceCategories();
    });
    this.setState({ isSubmit: false, isSuccessActive: false });
    this.closeModal();
  };

  editServiceCategory = (data: IServiceCategory) => {
    this.props.editServiceCategory(data).then(() => {
      this.props.getPageContentById(data.href).then((pageContent) => {
        this.props.editPageContent({
          pageId: pageContent[0].pageId,
          pageTitle: data.title,
          content: pageContent[0].content,
        });
      });

      this.props.getServiceCategories();
    });
  };

  delServiceCategory = (id: IServiceCategory["id"]) => {
    this.props.delServiceCategory(id).then(() => {
      this.props.delPageContent(`service-category.${id}`);
      this.props.getServiceCategories();
    });
  };

  onSuccessChange = (active: boolean) => {
    this.setState({ isSuccessActive: active });
  };

  render() {
    if (this.props.isLoading)
      return (
        <div className="loader-wrapper">
          <Loader />
        </div>
      );

    return (
      <div className="user-group">
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          contentLabel="Add phrase modal"
          className="user-group__modal"
          overlayClassName="user-group__overlay"
        >
          <button onClick={this.closeModal} className="modal-close" />
          <AddServiceCategory
            onSubmit={this.addServiceCategory}
            onSuccessChange={this.onSuccessChange}
            isSubmit={this.state.isSubmit}
          />
          {this.state.isSuccessActive && (
            <button
              onClick={() => this.setState({ isSubmit: true })}
              className="modal-success"
            />
          )}
        </Modal>

        <div className="user-group__header">
          <div className="header__back-button">
            <BackButton to="/" />
          </div>

          <div className="header__group-label">
            <p className="label__text">Категории услуг</p>
            <p className="label__counter">
              {this.props.serviceCategoriesList.length}
            </p>
            <button className="label__add-button" onClick={this.openModal} />
          </div>
        </div>

        <div className="user-group__content">
          <div className="column">
            {this.props.serviceCategoriesList.map((serviceCategory) => (
              <ServiceCategory
                serviceCategory={serviceCategory}
                onSubmit={this.editServiceCategory}
                onDelete={this.delServiceCategory}
                key={serviceCategory.id}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceCategoriesList;
